import { useCallback } from "react";

import { usePrivy } from "@privy-io/react-auth";
import { mutate } from "swr";

/**
 * Evict SWR entries on logout / Privy session change (keep portalItem).
 * Same filter historically used by logout — public keys are cleared too so a
 * later login cannot reuse prior-session authenticated payloads that share
 * non-user-scoped key shapes; callers pass revalidate:false to avoid a
 * thundering herd of public refetches.
 */
export function clearSessionCaches({ revalidate = false } = {}) {
  return mutate((key) => {
    if (Array.isArray(key) && key[1] === "portalItem") {
      return false;
    }
    return true;
  }, undefined, { revalidate });
}

export function useLogout() {
  const { logout: privyLogout } = usePrivy();
  const logout = useCallback(async () => {
    await privyLogout();
    clearSessionCaches({ revalidate: false });
  }, [privyLogout]);

  return { logout };
}
